import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import MuiButtonGroup from "@mui/material/ButtonGroup";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseButtonGroupProps = PropsWithChildren<{
  variant: "outlined" | "contained" | "text";
}>;

export type ButtonGroupProps = AtomProps<BaseButtonGroupProps>;

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ id, className, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiButtonGroup
      id={id}
      className={cx(styles.root, className)}
      classes={{
        contained: styles.contained,
        outlined: styles.outlined,
        text: styles.text,
      }}
      {...props}
    />
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    height: theme.spacing(18),
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
    },
    "&:focus": {
      boxShadow: "none",
    },
  }),
  contained: css({
    ">:not(:first-child)": {
      borderLeft: `1px solid ${theme.palette.common.white}`,
    },
  }),
  outlined: css({}),
  text: css({
    "&>*": {
      border: "none !important",
    },
  }),
});
